import { dateTimeFormatter } from './dateTimeFormatter';
import { getFromLocalStorage } from './localStorage';
import { _t } from 'app/utils/i18n';
const isEn = getFromLocalStorage('LNG') === 'en';

export const getTimeDifference = (date: string) => {
  const givenDate = new Date(date);
  const currentDate = new Date();
  const differenceInMilliseconds = currentDate.getTime() - givenDate.getTime();
  const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);
  const differenceInWeeks =
    differenceInMilliseconds / (1000 * 60 * 60 * 24 * 7);
  const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
  const differenceInMonths =
    (currentDate.getFullYear() - givenDate.getFullYear()) * 12 +
    (currentDate.getMonth() - givenDate.getMonth());
  const minutes = Math.floor(differenceInMilliseconds / 60000); // Convert to minutes
  const seconds = Math.floor((differenceInMilliseconds % 60000) / 1000);
  const differenceInYears = currentDate.getFullYear() - givenDate.getFullYear();
  const dates = {
    seconds: Math.round(seconds),
    minutes: Math.round(minutes),
    hours: Math.round(differenceInHours),
    weeks: Math.round(differenceInWeeks),
    days: Math.round(differenceInDays),
    months: differenceInMonths,
    years: differenceInYears,
  };
  

  const results =
    dates?.minutes < 61 && dates?.hours < 1
      ? !isEn
        ? `${_t('tweets:m')}${dates?.minutes}`
        : `${dates?.minutes}${_t('tweets:m')}`
      : dates?.seconds < 61 && dates?.minutes < 1 && dates?.hours < 1
        ? !isEn
          ? `${_t('tweets:s')}${dates?.seconds}`
          : `${dates?.seconds}${_t('tweets:s')}`
        : dates?.hours < 25
          ? !isEn
            ? `${_t('tweets:h')}${dates?.hours}`
            : `${dates?.hours}${_t('tweets:h')}`
          : dateTimeFormatter.date(date, `${!isEn ? 'dd LLLL' : 'LLL dd'}`);
  return results;
};
